import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatClient } from '../models/chat-client.model';

// Lists local (`app_clients`) accounts with the `Client` role for a clinic -- used exclusively to
// populate `CommunicationPage`'s new-conversation picker. Deliberately separate from
// `features/settings`'s `ILocalUsersRepository`, which only manages staff (`Admin`/`Worker`) rows.
export interface IChatClientsRepository {
  list(organizationId: number): Observable<readonly ChatClient[]>;
}

export const CHAT_CLIENTS_REPOSITORY = new InjectionToken<IChatClientsRepository>('IChatClientsRepository');
